import { Button, Col, Collapse, Form, Row, Table } from "react-bootstrap";
import { Participant } from "../../types/participant";
import { GIVEN_NAME, FAMILY_NAME, DOB, EMAIL, DUE_DATE, NO_UNLINKED_PARTICIPANTS, COMPLETE_LINK, CANCEL } from "../../util/const";
import { FormatDateForDisplay } from "../../util/data-utils";
import { useOrphanParticipants } from "../../services/useData";
import { useState } from "react";
import React from "react";
import InfoCards from "../../Components/InfoCards";
import { Patient } from "../../types/patient";

export type OrphanProps = {
  parentCallback: (subject?: Participant) => void;
  actionHeaderText: string;
  actionText: string;
  patient?: Patient;
};

const  OrphanParticipants = (props: OrphanProps) => {

  const fetchedData = useOrphanParticipants();
  const participants = fetchedData.participants;

  const [search, setSearch] = useState("");
  const onSearchInputChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const [open, setOpen] = useState(-1);

  const onCancel = () =>
  {
    if(props.patient !== undefined)
      setOpen(-1);
    props.parentCallback(undefined);
  }
  
  const onComplete = (participant: Participant) => 
  {
    if(props.patient !== undefined)
      setOpen(-1);
    props.parentCallback(participant);
  }

  const CollapseRow = (index: number, px: Participant) => {
    if(props.patient === undefined)
      return <></>
    return <tr>
      <Collapse in={open === index}>
        <td colSpan={6} id="example-collapse-text">
          <InfoCards participant={px} patient={props.patient!}></InfoCards>
          <div className="text-center mt-3 mb-3"><Button className="btn-color me-2" onClick={() => onCancel()}>{CANCEL}</Button>
          <Button className="btn-color me-2" onClick={() => onComplete(px)}>
            {COMPLETE_LINK}
          </Button>
          </div>
        </td>
      </Collapse>
    </tr>
  }
  
  if(participants && participants.length > 0)
  {
    return (
      <Table striped bordered hover>
        <thead>
          <tr key="searchRow">
            <th colSpan={6}>
              <Form>
                <Row>
                  <Col />
                  <Form.Group as={Col} controlId="search">
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={search}
                      onChange={onSearchInputChanged}
                      className="fs-6" />
                  </Form.Group>
                  <Col />
                </Row>
              </Form>
            </th>
          </tr>
          <tr>
            <th>{GIVEN_NAME}</th>
            <th>{FAMILY_NAME}</th>
            <th className="text-center">{DOB}</th>
            <th>{EMAIL}</th>
            <th className="text-center">{DUE_DATE}</th>
            <th className="text-center">{props.actionHeaderText}</th>
          </tr>
        </thead>
        <tbody>
        {
          participants.map((item: Participant, i: number) => {
            if (search === "" ||
              item.givenName.toLowerCase().includes(search.toLowerCase()) ||
              item.familyName.toLowerCase().includes(search.toLowerCase()) ||
              item.birthDate.toLowerCase().includes(search.toLowerCase()) ||
              item.email.toLowerCase().includes(search.toLowerCase()) ||
              item.dueDate.toLowerCase().includes(search.toLowerCase())) {
              return (
                <React.Fragment key={i}>
                <tr key={item.id} className="middle">
                  <td>{item.givenName}</td>
                  <td>{item.familyName}</td>
                  <td className="text-center">{FormatDateForDisplay(item.birthDate)}</td>
                  <td>{item.email}</td>
                  <td className="text-center">{FormatDateForDisplay(item.dueDate)}</td>
                  <td className="text-center">
                    <Button
                      className="btn-color"
                      onClick={() => {
                        if(props.patient)
                          setOpen(i);
                        else 
                          props.parentCallback(item);
                      }}
                      aria-controls="example-collapse-text">
                      {props.actionText}
                    </Button>
                  </td>
                </tr>
                {CollapseRow(i, item)}
                </React.Fragment>
              );
            }
            return (<></>)
          })
        }
        </tbody>
      </Table>
    );
  }
  return (<div className="color-text">{NO_UNLINKED_PARTICIPANTS}</div>);
}

export default OrphanParticipants;